// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__IH36b","ButtonActive":"Button_ButtonActive__Qf8Wi","fa-scroll":"Button_fa-scroll__T8hWx","notes":"Button_notes__cEmnY","notes_btn":"Button_notes_btn__EsFI9"};